<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title>
      <h1>{{ 'billing.articles.title' | translate }}</h1>
    </mat-card-title>
  </mat-card-header>

  <mat-card-content>

    <section class="formButton">
      <form [formGroup]="clientSiteForm" *ngIf="clientSiteForm" class="formClient" [class.hide]="isLoading">
        <div class="clientField">
          <app-autocomplete [control]="getControl('client')" [list]="clients" label="billing.articles.list.client">
          </app-autocomplete>
        </div>

        <div class="siteField">
          <app-autocomplete *ngIf="showSites && getControl('client').value" [control]="getControl('site')"
            [list]="sites" label="billing.articles.list.site">
          </app-autocomplete>
        </div>

        <button *ngIf="getControl('client').value" type="button" mat-raised-button color="primary"
          (click)="showArticles()" [disabled]="clientSiteForm.invalid">Filtrer</button>
      </form>

      <button *ngIf="getControl('client').value" color="primary" mat-raised-button [disabled]="isLoading"
        (click)="generateArticles()">Générer
        articles</button>

      <button *ngIf="getControl('client').value" color="primary" mat-raised-button [disabled]="isLoading"
        (click)="showIncompleteTariffs()" class="showIncomplete">Afficher les articles incomplets</button>
    </section>

    <section [hidden]="isLoading || !articlesFormated" class="datatable-articles">
      <table mat-table [dataSource]="dataSource" multiTemplateDataRows class="mat-elevation-z8">

        <ng-container matColumnDef="code">
          <th mat-header-cell *matHeaderCellDef [attr.rowspan]="2"> Code </th>
          <td mat-cell *matCellDef="let article;let i = dataIndex" [attr.rowspan]="article.stepsFormated.length"
            [style.display]="article.indexStep === 0 ? '' : 'none'">
            <div *ngIf="!article.isEditCode" class="editableRow">
              <div>
                {{ article.code }}
              </div>
              <button mat-icon-button class="action-button" color="primary" [disabled]="isLoading" matTooltip="Editer"
                (click)="onEditCodeArticle(article)">
                <mat-icon aria-label="Edit">edit</mat-icon>
              </button>
            </div>
            <div *ngIf="article.isEditCode" class="editInput">
              <mat-form-field>
                <input type="text" maxlength="50" matInput [(ngModel)]="article.code">
              </mat-form-field>

              <button mat-icon-button class="action-button" color="primary" [disabled]="isLoading"
                matTooltip="Mettre à jour" (click)="onCodeUpdate(article)">
                <mat-icon aria-label="Update">check</mat-icon>
              </button>

              <button mat-icon-button class="action-button" color="primary" [disabled]="isLoading" matTooltip="Annuler"
                (click)="onCancel(article)">
                <mat-icon aria-label="Cancel">clear</mat-icon>
              </button>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="estimatedTime">
          <th mat-header-cell *matHeaderCellDef> Temps estimé</th>
          <td mat-cell *matCellDef="let article" [attr.rowspan]="article.stepsFormated.length"
            [style.display]="article.indexStep === 0 ? '' : 'none'">
            <div *ngIf="!article.isEditEstimatedTime" class="editableRow">
              <div>
                <span *ngIf="article.estimatedTime">
                  {{ article.estimatedTime }} min
                </span>
              </div>
              <button mat-icon-button class="action-button" color="primary" [disabled]="isLoading" matTooltip="Editer"
                (click)="onEditEstimatedTime(article)">
                <mat-icon aria-label="Edit">edit</mat-icon>
              </button>
            </div>
            <div *ngIf="article.isEditEstimatedTime" class="editInput">
              <mat-form-field>
                <input type="number" min="0" matInput [(ngModel)]="article.estimatedTime">
              </mat-form-field>

              <button mat-icon-button class="action-button" color="primary" [disabled]="isLoading"
                matTooltip="Mettre à jour" (click)="onEstimatedTimeUpdate(article)">
                <mat-icon aria-label="Update">check</mat-icon>
              </button>

              <button mat-icon-button class="action-button" color="primary" [disabled]="isLoading" matToolTip="Annuler"
                (click)="onCancelUpdateEstimatedTime(article)">
                <mat-icon aria-label="Cancel">clear</mat-icon>
              </button>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="site">
          <th mat-header-cell *matHeaderCellDef> Donneur d'ordre </th>
          <td mat-cell *matCellDef="let article;let i = dataIndex" [attr.rowspan]="article.stepsFormated.length"
            [style.display]="article.indexStep === 0 ? '' : 'none'">
            {{article.site.name}}
          </td>
        </ng-container>

        <ng-container matColumnDef="sender">
          <th mat-header-cell *matHeaderCellDef> Expéditeur </th>
          <td mat-cell *matCellDef="let article;let i = dataIndex" [attr.rowspan]="article.stepsFormated.length"
            [style.display]="article.indexStep === 0 ? '' : 'none'">
            <ng-container *ngIf="article.sender.address">{{ article.sender.address.name }} </ng-container>
            <ng-container *ngIf="!article.sender.address">{{ article.sender.otherAddress }} </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="lot">
          <th mat-header-cell *matHeaderCellDef> Lot / Objet du transport </th>
          <td mat-cell *matCellDef="let article;let i = dataIndex" [attr.rowspan]="article.stepsFormated.length"
            [style.display]="article.indexStep === 0 ? '' : 'none'">
            {{ article.lot?.name }}
          </td>
        </ng-container>

        <ng-container matColumnDef="urgency">
          <th mat-header-cell *matHeaderCellDef> Niveau d'urgence </th>
          <td mat-cell *matCellDef="let article;let i = dataIndex" [attr.rowspan]="article.stepsFormated.length"
            [style.display]="article.indexStep === 0 ? '' : 'none'">
            {{ article.urgency.name }}
          </td>
        </ng-container>

        <ng-container matColumnDef="step">
          <th mat-header-cell *matHeaderCellDef> Étape </th>
          <td mat-cell *matCellDef="let article" class="stepCell">
            <ng-container *ngIf="article.step.address">{{ article.step.address.name }} </ng-container>
            <ng-container *ngIf="!article.step.address">{{ article.step.otherAddress }} </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="daysWeekDay">
          <th mat-header-cell *matHeaderCellDef> Jour </th>
          <td mat-cell *matCellDef="let article">
            <div *ngIf="!article.isEdit">
              {{article.daysWeek.dayPrice}}
            </div>
            <div *ngIf="article.isEdit">
              <mat-form-field class="inputNumber">
                <input type="number" min="0" matInput [(ngModel)]="article.daysWeek.dayPrice">
              </mat-form-field>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="daysWeekDayPackage">
          <th mat-header-cell *matHeaderCellDef class="package"> Forfait </th>
          <td mat-cell *matCellDef="let article" class="package">
            <div *ngIf="!article.isEdit">
              {{article.daysWeek.dayPackage}}
            </div>
            <div *ngIf="article.isEdit">
              <mat-form-field class="inputNumber">
                <input type="number" min="0" matInput [(ngModel)]="article.daysWeek.dayPackage">
              </mat-form-field>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="daysWeekNight">
          <th mat-header-cell *matHeaderCellDef> Nuit </th>
          <td mat-cell *matCellDef="let article">
            <div *ngIf="!article.isEdit">
              {{article.daysWeek.nightPrice}}
            </div>
            <div *ngIf="article.isEdit">
              <mat-form-field class="inputNumber">
                <input type="number" min="0" matInput [(ngModel)]="article.daysWeek.nightPrice">
              </mat-form-field>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="daysWeekNightPackage">
          <th mat-header-cell *matHeaderCellDef class="package"> Forfait </th>
          <td mat-cell *matCellDef="let article" class="package">
            <div *ngIf="!article.isEdit">
              {{article.daysWeek.nightPackage}}
            </div>
            <div *ngIf="article.isEdit">
              <mat-form-field class="inputNumber">
                <input type="number" min="0" matInput [(ngModel)]="article.daysWeek.nightPackage">
              </mat-form-field>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="saturdayDay">
          <th mat-header-cell *matHeaderCellDef> Jour </th>
          <td mat-cell *matCellDef="let article">
            <div *ngIf="!article.isEdit">
              {{article.saturday.dayPrice}}
            </div>
            <div *ngIf="article.isEdit">
              <mat-form-field class="inputNumber">
                <input type="number" min="0" matInput [(ngModel)]="article.saturday.dayPrice">
              </mat-form-field>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="saturdayDayPackage">
          <th mat-header-cell *matHeaderCellDef class="package"> Forfait </th>
          <td mat-cell *matCellDef="let article" class="package">
            <div *ngIf="!article.isEdit">
              {{article.saturday.dayPackage}}
            </div>
            <div *ngIf="article.isEdit">
              <mat-form-field class="inputNumber">
                <input type="number" min="0" matInput [(ngModel)]="article.saturday.dayPackage">
              </mat-form-field>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="saturdayNight">
          <th mat-header-cell *matHeaderCellDef> Nuit </th>
          <td mat-cell *matCellDef="let article">
            <div *ngIf="!article.isEdit">
              {{article.saturday.nightPrice}}
            </div>
            <div *ngIf="article.isEdit">
              <mat-form-field class="inputNumber">
                <input type="number" min="0" matInput [(ngModel)]="article.saturday.nightPrice">
              </mat-form-field>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="saturdayNightPackage">
          <th mat-header-cell *matHeaderCellDef class="package"> Forfait </th>
          <td mat-cell *matCellDef="let article" class="package">
            <div *ngIf="!article.isEdit">
              {{article.saturday.nightPackage}}
            </div>
            <div *ngIf="article.isEdit">
              <mat-form-field class="inputNumber">
                <input type="number" min="0" matInput [(ngModel)]="article.saturday.nightPackage">
              </mat-form-field>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="sundayDay">
          <th mat-header-cell *matHeaderCellDef> Jour </th>
          <td mat-cell *matCellDef="let article">
            <div *ngIf="!article.isEdit">
              {{article.sunday.dayPrice}}
            </div>
            <div *ngIf="article.isEdit">
              <mat-form-field class="inputNumber">
                <input type="number" min="0" matInput [(ngModel)]="article.sunday.dayPrice">
              </mat-form-field>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="sundayDayPackage">
          <th mat-header-cell *matHeaderCellDef class="package"> Forfait </th>
          <td mat-cell *matCellDef="let article" class="package">
            <div *ngIf="!article.isEdit">
              {{article.sunday.dayPackage}}
            </div>
            <div *ngIf="article.isEdit">
              <mat-form-field class="inputNumber">
                <input type="number" min="0" matInput [(ngModel)]="article.sunday.dayPackage">
              </mat-form-field>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="sundayNight">
          <th mat-header-cell *matHeaderCellDef> Nuit </th>
          <td mat-cell *matCellDef="let article">
            <div *ngIf="!article.isEdit">
              {{article.sunday.nightPrice}}
            </div>
            <div *ngIf="article.isEdit">
              <mat-form-field class="inputNumber">
                <input type="number" min="0" matInput [(ngModel)]="article.sunday.nightPrice">
              </mat-form-field>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="sundayNightPackage">
          <th mat-header-cell *matHeaderCellDef class="package"> Forfait </th>
          <td mat-cell *matCellDef="let article" class="package">
            <div *ngIf="!article.isEdit">
              {{article.sunday.nightPackage}}
            </div>
            <div *ngIf="article.isEdit">
              <mat-form-field class="inputNumber">
                <input type="number" min="0" matInput [(ngModel)]="article.sunday.nightPackage">
              </mat-form-field>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef [attr.colspan]="2" class="actionsCell"> Actions </th>
          <td mat-cell *matCellDef="let article">
            <ng-container *ngIf="!article.isEdit">
              <button mat-icon-button class="action-button" color="primary" [disabled]="isLoading" matTooltip="Editer"
                (click)="onEditArticle(article)">
                <mat-icon aria-label="Edit">edit</mat-icon>
              </button>

            </ng-container>
            <ng-container *ngIf="article.isEdit">
              <button mat-icon-button class="action-button" color="primary" [disabled]="isLoading"
                matTooltip="Mettre à jour" (click)="onUpdate(article)">
                <mat-icon aria-label="Update">check</mat-icon>
              </button>
              <button mat-icon-button class="action-button" color="primary" [disabled]="isLoading" matTooltip="Annuler"
                (click)="onCancel(article)">
                <mat-icon aria-label="Cancel">clear</mat-icon>
              </button>
            </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="onDelete">
          <th mat-header-cell *matHeaderCellDef class="actionsCell"> </th>
          <td mat-cell *matCellDef="let article" [attr.rowspan]="article.stepsFormated.length"
            [style.display]="article.indexStep === 0 ? '' : 'none'" class="deleteCell">
            <ng-container *ngIf="!editedId">
              <button mat-icon-button class="action-button" color="primary" [disabled]="isLoading"
                matTooltip="Supprimer" (click)="onDeleteArticle(article.id)">
                <mat-icon aria-label="Edit">delete</mat-icon>
              </button>
            </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="codeHeader">
          <th mat-header-cell *matHeaderCellDef [style.text-align]="center" [attr.colspan]="1">
            Code article
          </th>
        </ng-container>

        <ng-container matColumnDef="estimatedTimeHeader">
          <th mat-header-cell *matHeaderCellDef [style.text-align]="center" [attr.colspan]="1">
            Temps
          </th>
        </ng-container>

        <ng-container matColumnDef="siteHeader">
          <th mat-header-cell *matHeaderCellDef [style.text-align]="center" [attr.colspan]="1">

          </th>
        </ng-container>

        <ng-container matColumnDef="filterSender">
          <th mat-header-cell *matHeaderCellDef [style.text-align]="center" [attr.colspan]="1">
            <div class="cellTh">
              <div class="autocompleteFilter">
                <app-autocomplete-filter *ngIf="!isLoadingFilterForm && filterForm" [valueWanted]="'name'"
                  [control]="filterForm.get('sender')" [list]="senders" (click)="$event.stopPropagation()"
                  (keydown.enter)="$event.stopPropagation(); onFilter()">
                </app-autocomplete-filter>
              </div>
            </div>
          </th>
        </ng-container>

        <ng-container matColumnDef="filterLot">
          <th mat-header-cell *matHeaderCellDef [style.text-align]="center" [attr.colspan]="1">
            <div class="cellTh">
              <div class="autocompleteFilter" *ngIf="lots">
                <app-autocomplete-filter *ngIf="!isLoadingFilterForm && filterForm" [valueWanted]="'name'"
                  [control]="filterForm.get('lot')" [list]="lots" (click)="$event.stopPropagation()"
                  (keydown.enter)="$event.stopPropagation(); onFilter($event)">
                </app-autocomplete-filter>
              </div>
            </div>
          </th>
        </ng-container>

        <ng-container matColumnDef="filterUrgency">
          <th mat-header-cell *matHeaderCellDef [style.text-align]="center" [attr.colspan]="1">
            <div class="cellTh">
              <div class="autocompleteFilter">
                <app-autocomplete-filter *ngIf="!isLoadingFilterForm && filterForm" [valueWanted]="'name'"
                  [control]="filterForm.get('urgency')" [list]="urgencyLevels" (click)="$event.stopPropagation()"
                  (keydown.enter)="$event.stopPropagation(); onFilter($event)">
                </app-autocomplete-filter>
              </div>
            </div>
          </th>
        </ng-container>

        <ng-container matColumnDef="filterStep">
          <th mat-header-cell *matHeaderCellDef [style.text-align]="center" [attr.colspan]="1">
            <div class="cellTh">
              <div class="autocompleteFilter">
                <app-autocomplete-filter *ngIf="!isLoadingFilterForm && filterForm" [valueWanted]="'name'"
                  [control]="filterForm.get('step')" [list]="receivers" (click)="$event.stopPropagation()"
                  (keydown.enter)="$event.stopPropagation(); onFilter()">
                </app-autocomplete-filter>
              </div>
            </div>
          </th>
        </ng-container>

        <ng-container matColumnDef="weekDays">
          <th mat-header-cell *matHeaderCellDef [attr.colspan]="4"> Semaine </th>
        </ng-container>

        <ng-container matColumnDef="saturday">
          <th mat-header-cell *matHeaderCellDef [attr.colspan]="4"> Samedi </th>
        </ng-container>

        <ng-container matColumnDef="sunday">
          <th mat-header-cell *matHeaderCellDef [attr.colspan]="4" class="sundayCol"> Dimanche/jours fériés </th>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="headerColumns">
        </tr>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="row"></tr>
      </table>
    </section>

    <mat-spinner *ngIf="isLoading" [diameter]="35" color="primary" class="spinner"></mat-spinner>

  </mat-card-content>
</mat-card>
